<div
  class="row with-gap justify-space-between performance-indicator-title-container"
  >
  <div class="row">
    <div class="column performance-indicator-title-h4">
      {{model.name | uppercase}}
      <span class="greyed-out-text" [attr.data-pi-unit-for]="model.name + ' ' + model.resourceClassificationIdentifier"> {{ model.unitSymbol }}</span>
    </div>
  </div>
  @if (performanceIndicatorDescription) {
    <app-icon-tooltip
      [tooltipIconId]="getTooltipIconId()"
      [iconType]="iconType.Info"
      >
      <p>{{ performanceIndicatorDescription }}</p>
    </app-icon-tooltip>
  }
</div>
<div
  class="container"
  [class.afterPercentageColorBar]="
    model.hasTargets && model.targetType !== targetTypes.None
  "
  [style.width.rem]="width"
  [style.height.rem]="height"
  >
  @if (model.hasTargets == true && hasTargetValue == true) {
    <div
      [style.width.%]="actualWidth"
      [style.height.rem]="height"
      [ngClass]="getPerformanceBarColor()"
    ></div>
  }
  <div class="percentage row grow justify-space-between align-items-center">
    <div [attr.data-pi-value-for]="model.name + ' ' + model.resourceClassificationIdentifier">{{ actualValue }}</div>
    <div></div>
    @if (model.hasTargets && model.targetType !== targetTypes.None) {
      <div>
        @if (hasTargetValue) {
          <span [attr.data-pi-percentage-for]="model.name + ' ' + model.resourceClassificationIdentifier">{{
            actualPercentage
          }}</span>
        } @else {
          <span>{{ "Shell.generic.na" | translate }}</span>
        }
      </div>
    }
  </div>
</div>
<div class="row justify-space-between actions-container">
  <div
    class="greyed-out-text"
    (click)="showPerformanceIndicatorDetailsGraph($event)"
    >
    {{ "Shell.general.showGraph" | translate }}
  </div>
  @if (shouldEditTargetButtonAppear()) {
    <div
      class="greyed-out-text"
      (click)="onAddEditBudget()"
      >
      {{ buttonName | lowercase }}
    </div>
  }
</div>
